import React, { useState } from "react";

import PredicateChain from "../../../../common/PredicateChain";

import SideBarItem from "./SideBarItem";

export default (({
  classes,
  ancestor,
  custom_pid,
  formAncestor,
  sidebarPidsItems,
  sidebarGeneralItems,
  setCustomAncestorToFormState,
}) => {
  const [pids, setPids] = useState([]);

  return (
    <div className={classes.sideBar}>
      {formAncestor ?
      <span style={{ fontSize: '11px' }}>Pid for parent mode:</span>
      : null}

      <div style={{ width: '100%', pointerEvents: pids && pids.length ? 'none' : '' }}>
        <PredicateChain
          objectTypeOnly={true}
          mode={"edit"}
          rst={custom_pid || []}
          ancestor={formAncestor}
          addInnerRstCb={({ newSelected }) => {
            setCustomAncestorToFormState(newSelected)
          }}
          onRemoveRstCb={(props, newSelected) => {
            setCustomAncestorToFormState(newSelected);
            setPids([]);
          }}
        />
      </div>

      <div className={classes.mt20}>
        <span style={{ fontSize: '11px' }}>Chain for component item:</span>

        <div style={{ width: '100%' }}>
          <PredicateChain
            mode="edit"
            rst={pids}
            showType={true}
            ancestor={ancestor}
            addInnerRstCb={({ newSelected }) => {
              setPids(newSelected);
            }}
            onRemoveRstCb={(props, newSelected) => {
              setPids(newSelected);
            }}
          />
        </div>
      </div>
      
      {pids && pids.length ?
        <div className={classes.mt10}>
          {Object.values(sidebarPidsItems).map((sideBarItem, index) => (
            <SideBarItem
              pids={pids}
              ancestor={ancestor}
              data={sideBarItem}
              key={sideBarItem.id}
              className={classes.sideBarItem}
            />
          ))}
        </div>
      : null}

      <div className={classes.mt40}>
        {Object.values(sidebarGeneralItems).map((sideBarItem, index) => (
          <SideBarItem
            data={sideBarItem}
            key={sideBarItem.id}
            className={classes.sideBarItem}
          />
        ))}
      </div>
    </div>
  )
});
